module.exports = __webpack_public_path__ + "img/Path_up.2d09bb4a.svg";